import { Divider, Grid } from "@mui/material";
import { convertToJalali, formatGregorianDate } from "../../../../utils/date";
import { numberWithCommas } from "../../../../utils/utility";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../../routing/LangRouter";
import { useContext } from "react";

//import view components
import IntFlightOrder from "./int-flight-order";
import DomesticFlightOrder from "./domestic-flight-order";


function FlightOrders({ orderItem, handleClick }) {
    const { t } = useTranslation();
    const { locale } = useContext(LocaleContext);

    return (
        <Grid
            className="orders__order-item"
            container
            item
            xs={12}
            rowGap={2}
            alignItems="flex-start"
            onClick={() => handleClick("flight", orderItem.flight?.is_international, orderItem)}
        >
            <Grid container item xs={12} columnGap={1} alignItems="center">
                <span className={`orders__label orders__label--${orderItem?.get_status?.en}`}>{locale === "en" ? orderItem?.get_status?.en: orderItem?.get_status?.fa}</span>
                <span className="orders__label orders__label--date">
                     {`${t("General.Order Date")}`} :  {locale === "fa" ?  convertToJalali(orderItem?.create_date) : formatGregorianDate(orderItem?.create_date, null, "YYYY/MM/DD")}
                </span>
                <span className="orders__label orders__label--tracking-code">
                    {t("trackingCode")}: {orderItem?.tracking_code}
                </span>
            </Grid>

            {orderItem.flight?.is_international ? <IntFlightOrder order={orderItem?.flight} /> : <DomesticFlightOrder order={orderItem?.flight} />}

            <Divider width="100%" />

            <Grid container item xs={12} justifyContent="flex-end" alignItems="center">
                <span className="orders__order-price">{t("amount")}: {numberWithCommas(orderItem?.flight?.fares?.total_price)}</span>
            </Grid>
        </Grid>
    );
}

export default FlightOrders;
